"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Edit = void 0;
var react_1 = __importDefault(require("react"));
var constants_1 = require("../constants");
var colors_1 = require("../../colors");
var Edit = function (_a) {
    var color = _a.color, height = _a.height, size = _a.size, width = _a.width;
    return (react_1.default.createElement("svg", { width: width || size || constants_1.DEFAULT_ICON_SIZE, height: height || size || constants_1.DEFAULT_ICON_SIZE, viewBox: '0 0 16 16', fill: 'none', xmlns: 'http://www.w3.org/2000/svg' },
        react_1.default.createElement("path", { d: 'M3 11.0336V12.7223C3 12.8778 3.12221 13 3.27774 13H4.96639C5.03861 13 5.11082 12.9722 5.16081 12.9167L11.2266 6.85641L9.14359 4.77336L3.08332 10.8336C3.02777 10.8892 3 10.9558 3 11.0336ZM12.8375 5.24552C13.0542 5.02888 13.0542 4.67893 12.8375 4.4623L11.5377 3.16248C11.3211 2.94584 10.9711 2.94584 10.7545 3.16248L9.73795 4.179L11.821 6.26205L12.8375 5.24552Z', fill: color ? (0, colors_1.getColor)(color) : 'currentColor' })));
};
exports.Edit = Edit;
